import { Component, inject, input, output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import {
    PrivaFilterSearchComponent,
    PrivaFilterSearchConfig,
    PrivaQueryableDataSource,
    PrivaQueryableDataSourceFactory,
} from '@priva/components/filter';
import { PrivaNotificationModule } from '@priva/components/notification';
import { PrivaTableColumnDirective, PrivaTableComponent, PrivaTableRowEvent } from '@priva/components/table';
import { PrivaLocalizationModule } from '@priva/localization';

import { Activity } from '../activity-selector/models';
import { Locations } from '../location-selector/models';
import { TerminalOverlayComponent } from './../../components';
import { LocationSelectorStore } from './location-selector.store';

@Component({
    selector: 'app-location-selector',
    templateUrl: './location-selector.component.html',
    styleUrl: './location-selector.component.scss',
    imports: [
        TerminalOverlayComponent,
        PrivaFilterSearchComponent,
        PrivaLocalizationModule,
        PrivaNotificationModule,
        PrivaTableComponent,
        PrivaTableColumnDirective,
    ],
    providers: [LocationSelectorStore],
})
export class LocationSelectorComponent {
    private componentStore = inject(LocationSelectorStore);
    private dataSourceFactory = inject(PrivaQueryableDataSourceFactory);

    title = input('');
    activity = input(undefined, {
        transform: (value: Activity | undefined) => {
            this._activity = value;
            this.componentStore.updateActivityAndLocationList({
                activity: value,
            });
            return this._activity;
        },
    });

    closeRequested = output<void>();
    locationSelected = output<Locations>();

    locationList: Locations[] = [];

    onCloseRequested(): void {
        this.closeRequested.emit();
    }

    _activity: Activity | undefined;

    // Filter
    filterSearchConfig: PrivaFilterSearchConfig = {
        type: 'search',
        id: 'searchLocation',
        title: 'GENERAL.TITLE.SEARCH_LOCATION',
        placeholder: 'GENERAL.TITLE.SEARCH_LOCATION',
        options: ['name'],
        searchOptions: {
            matchType: 'single',
        },
    };

    readonly locationDataSource: PrivaQueryableDataSource<Locations>;

    constructor() {
        this.componentStore.locationList$.pipe(takeUntilDestroyed()).subscribe((data) => {
            this.locationList = data;
        });

        // Update location list based on search filter
        this.locationDataSource = this.dataSourceFactory.create();
        this.locationDataSource.setData(this.componentStore.locationList$);
        this.locationDataSource.results$.pipe(takeUntilDestroyed()).subscribe((filteredLocations) => {
            this.locationList = filteredLocations;
        });
    }

    onTableRowClick(event: PrivaTableRowEvent<Locations>) {
        const location = event.row;
        this.locationSelected.emit(location);
    }
}
